<template>
  <div class="fade-in">
    <div class="columns">
      <div class="column is-full">
        <h1 class="title">Help</h1>
        <div class="is-clearfix"></div>

        <p>
          We welcome your request for assistance and support! Please be as
          detailed as possible with your request, but as always, please be
          careful to not disclose Private Healthcare Information (PHI) in the
          contents of your email.
        </p>

        <p>&nbsp;</p>

        <p>
          Please email us at
          <a target="_blank" href="mailto:support@healeo.net"
            >support@healeo.net</a
          >
          and we will respond as soon as possible.
        </p>

        <p>&nbsp;</p>

        <p>Please Include:</p>

        <p>&nbsp;</p>

        <p>
          Your full name
          <br />Detailed description of your support request <br />Your best
          contact number <br />Your best email address
        </p>

        <p>&nbsp;</p>

        <p>Thank you, and we look forward to serving you!</p>

        <p>&nbsp;</p>

        <p>Your Virtriage Support Team</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "help"
};
</script>

<style>
.help {
  font-size: 1rem;
}
</style>
